import { IAuthenticatedUser } from "../authenticated-user.interface";
import { IResult } from "./result.interface";

export interface ILoginResult extends IResult<IAuthenticatedUser> {
  failReason?: LoginFailureReason;
}

export enum LoginFailureReason {
  InvalidCredentials = 1,
  PasswordExpired,
  Blocked,
  Unknown,
}
